(function(){
if(window.__vxmg)return;window.__vxmg=1;
function liga(){
 document.querySelectorAll('[data-vxmg]').forEach(function(g){
  if(g.dataset.on)return;g.dataset.on='1';
  var t=g.querySelector('[data-vxmg-trilho]');if(!t)return;
  var bs=g.querySelectorAll('[data-vxmg-ir]');
  function passo(){var i=t.querySelector('.vxmg__i');return i?i.getBoundingClientRect().width+12:t.clientWidth}
  function att(){var f=t.scrollLeft<=2,l=t.scrollLeft+t.clientWidth>=t.scrollWidth-2;
   bs.forEach(function(b){b.disabled=(b.dataset.vxmgIr==='-1')?f:l})}
  bs.forEach(function(b){b.addEventListener('click',function(){
   t.scrollBy({left:passo()*parseInt(b.dataset.vxmgIr,10),behavior:'smooth'});setTimeout(att,420)})});
  t.addEventListener('scroll',att);att();
 });
}
document.addEventListener('click',function(e){
 var b=e.target.closest('.vxmg__v[data-vxvid]');if(!b)return;
 var i=document.createElement('iframe');i.className='vxmg__if';i.setAttribute('allowfullscreen','');
 i.setAttribute('allow','accelerometer;autoplay;clipboard-write;encrypted-media;gyroscope;picture-in-picture');
 i.setAttribute('title','Vídeo do produto');i.loading='lazy';
 i.src='https://www.youtube-nocookie.com/embed/'+b.dataset.vxvid+'?autoplay=1&rel=0';
 b.replaceWith(i)});
if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',liga);else liga();
document.addEventListener('shopify:section:load',liga);
})();
